import SlardarLogger from './slardar-logger';

const commonExtra = {} as Record<string, unknown>;

const isSSR = typeof window === 'undefined';

const logger = new SlardarLogger(isSSR ? undefined : (window as any)?.Slardar, commonExtra);

export default logger;
